export default function (Component) {
Component.options.__title = "Example: Adding Entries & Sorting"
}